<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body" :id="readonly ? '' : 'quota-container'">
                <div class="row">
                    <div class="form-group col-sm-12 col-md-12">
                        <label class="font-weight-bold required">{{$t('rankingCriteria.editor.type')}}</label>
                        <kendo-dropdownlist v-model="model.quotaType"
                                            :data-source="filteredQuotaTypes"
                                            :data-text-field=" isEnVersion ? 'textEn' : 'text'"
                                            :data-value-field="'value'"
                                            :clear-button="true"
                                            :filter="'contains'"
                                            :popup="popup"
                                            :name="'quotaType' + _uid"
                                            :id="'quotaType' + _uid"
                                            v-validate="'required'"
                                            :data-vv-as="$t('rankingCriteria.editor.type')"
                                            :disabled="readonly"
                                            :height="500"
                                            style="width:100%">
                        </kendo-dropdownlist>
                        <span class="text-danger col-12" v-if="errors.has('quotaType' + _uid)">{{ errors.first('quotaType' + _uid) }}</span>
                    </div>
                </div>

                <kendo-datasource ref="fieldDatasource"
                                  :transport="fieldTransportSettings"
                                  :server-filtering="false"
                                  :server-paging="false"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="fieldSchemaModel">
                </kendo-datasource>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6" v-if="showSearchValueDropdown">
                        <label class="font-weight-bold required">{{rankingQuotaValueLabel}}</label>
                        <kendo-autocomplete :data-source-ref="'rankingQuotaDatasource'"
                                            :data-text-field="'text'"
                                            v-model="model.filterValue"
                                            :separator="' / '"
                                            :filter="'contains'"
                                            :placeholder="$t('choose')"
                                            :clear-button="true"
                                            :popup="popup"
                                            :name="'filterValue' + _uid"
                                            :id="'filterValue' + _uid"
                                            :data-vv-as="rankingQuotaValueLabel"
                                            v-validate="'required'"
                                            :disabled="readonly"
                                            :height="500"
                                            style="width:100%"
                                            aria-describedby="FilterValueHelper">
                            <kendo-datasource ref="rankingQuotaDatasource"
                                              slot="kendo-datasource"
                                              :transport="transportSettings"
                                              :server-filtering="true"
                                              :schema-data="'data'">
                            </kendo-datasource>
                        </kendo-autocomplete>
                        <span class="text-danger col-12" v-if="errors.has('filterValue' + _uid)">{{ errors.first('filterValue' + _uid) }}</span>
                        <small id="FilterValueHelper" class="form-text text-muted">{{$t('rankingCriteria.editor.help.searchValue')}}</small>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="model.quotaType">
                        <label class="font-weight-bold required">{{$t('rankingCriteria.editor.count')}}</label>
                        <input type="number" min="1"
                               class="form-control"
                               v-model="model.count"
                               :name="'count' + _uid"
                               :id="'count' + _uid"
                               v-validate="'required'"
                               :disabled="readonly"
                               :data-vv-as="$t('rankingCriteria.editor.count')" />
                        <span class="text-danger col-12" v-if="errors.has('count' + _uid)">{{ errors.first('count' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="eventId">
                        <label class="font-weight-bold" :class="model.quotaType && model.quotaType == rankingQuotaType.FieldValue ? 'required' : ''">{{$t('rankingCriteria.editor.searchFieldName')}}</label>
                        <kendo-dropdownlist v-model="model.searchFieldName"
                                            :data-source-ref="'fieldDatasource'"
                                            :data-text-field=" isEnVersion ? 'textEn' : 'text'"
                                            :data-value-field="'text'"
                                            :clear-button="true"
                                            :popup="popup"
                                            :filter="'contains'"
                                            :optionLabel="$t('choose')"
                                            :name="'searchFieldName' + _uid"
                                            :id="'searchFieldName' + _uid"
                                            :disabled="readonly"
                                            :height="500"
                                            style="width:100%"
                                            :data-vv-as="$t('rankingCriteria.editor.searchFieldName')"
                                            v-validate="model.quotaType && model.quotaType == rankingQuotaType.FieldValue ? 'required' : ''"
                                            @change="onSearchFieldChange"
                                            aria-describedby="searchFieldNameHelp">
                        </kendo-dropdownlist>
                        <span class="text-danger col-12" v-if="errors.has('searchFieldName' + _uid)">{{ errors.first('searchFieldName' + _uid) }}</span>
                        <small id="searchFieldNameHelp" class="form-text text-muted">
                            {{$t('rankingCriteria.editor.help.searchFieldName')}}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="eventId && model.quotaType">
                        <div v-if="model.quotaType == rankingQuotaType.FieldValue">
                            <label class="font-weight-bold required">{{$t('rankingCriteria.editor.operator')}}</label>
                            <kendo-dropdownlist v-model="model.operator"
                                                :data-source="operators"
                                                :auto-bind="false"
                                                :cascade-from="'searchFieldName' + _uid"
                                                :cascade-from-field="'fielTypeId'"
                                                :cascade-from-parent-field="'parentId'"
                                                :data-text-field=" isEnVersion ? 'textEn' : 'text'"
                                                :data-value-field="'value'"
                                                :clear-button="true"
                                                :popup="popup"
                                                :filter="'contains'"
                                                :optionLabel="$t('choose')"
                                                :name="'operator' + _uid"
                                                :id="'operator' + _uid"
                                                :disabled="readonly"
                                                :data-vv-as="$t('rankingCriteria.editor.operator')"
                                                :height="500"
                                                v-validate="'required'"
                                                style="width:100%">
                            </kendo-dropdownlist>
                            <span class="text-danger col-12" v-if="errors.has('operator' + _uid)">{{ errors.first('operator' + _uid) }}</span>
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="eventId && model.quotaType">
                        <div v-if="model.quotaType == rankingQuotaType.FieldValue">
                            <label class="font-weight-bold">{{$t('rankingCriteria.editor.fieldValue')}}</label>
                            <div v-if="model.fildType == fildType.Bool">
                                <vs-checkbox v-model="model.filterValue"
                                             :name="'filterValue' + _uid"
                                             :id="'filterValue' + _uid"
                                             :disabled="readonly"
                                             style="justify-content: flex-start !important">
                                </vs-checkbox>
                            </div>
                            <div v-else-if="model.fildType == fildType.Date">
                                <date-picker v-model="model.filterValue"
                                             :showTime="true"
                                             :readonly="readonly"
                                             :convertDateToUtc="false"
                                             :bindPopup="true"
                                             :popupContainerId="'#quota-container'">
                                </date-picker>
                            </div>
                            <div v-else>
                                <input :type="model.fildType == fildType.Number ? 'number' : 'text'"
                                       class="form-control"
                                       v-model="model.filterValue"
                                       :name="'fieldValue' + _uid"
                                       :id="'fieldValue' + _uid"
                                       v-validate="'required'"
                                       :disabled="readonly"
                                       :data-vv-as="$t('rankingCriteria.editor.fieldValue')" />
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <button v-if="!readonly" type="button" class="btn btn-sm btn-danger" @click.stop="deleteQuota"><i class="far fa-trash-alt mr-2"></i>{{ $t('buttons.delete.btnText')}}</button>
                </div>
            </div>
            <div class="card-footer text-muted" v-if="model.fulfillment">
                <span class="m-1"><strong>{{ model.fulfillment }}</strong></span>
            </div>
        </div>
    </div>
</template>

<script>
    import { RankingQuota } from '../../models/models';
    import { RankingQuotaType, FildType } from '../../models/enums';
    import DatePicker from '../../components/datepicker/DateTimePicker';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: [Object, RankingQuota],
                required: true
            },
            readonly: {
                type: Boolean,
                default: true
            },
            eventId: {
                type: [Number, String]
            }
        },
        components: {
            DatePicker,
        },
        data() {
            return {
                model: this.value,
                rankingQuotaType: RankingQuotaType,
                fildType: FildType,
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/rankingCriteria/quotaTypeDropdownSource`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                popup: {
                    appendTo: $("#quota-container")
                },
                fieldTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/dynamicForms/getFieldsForEventDropdownSource/`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                fieldSchemaModel: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: true },
                    parentId: { name: 'parentId', from: 'parentId', type: 'number', nullable: true },
                    text: { name: 'text', from: 'text', type: 'string', nullable: true },
                    textEn: { name: 'textEn', from: 'textEn', type: 'string', nullable: true },
                    addData: { name: 'addData', from: 'addData', type: 'string', nullable: true },
                },
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.authToken) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.authToken);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    const newOptions = { eventId: this.eventId, quotaType: this.model.quotaType, request: options };
                    return kendo.stringify(newOptions);
                }
            },
            deleteQuota() {
                if (this.model) {
                    this.$emit("delete", this.model);
                }
            },
            onSearchFieldChange(e) {
                const idx = e.sender.selectedIndex - 1;
                if (idx >= 0) {
                    this.model.fildType = e.sender.dataSource.view()[idx]['parentId'];
                } else {
                    this.model.fildType = '';
                }

                this.model.filterValue = '';
            },
        },
        mounted() {
        },
        computed: {
            ...mapGetters(['isEnVersion', 'quotaTypes', 'authToken', 'operators', 'dateTimeFormat']),
            filteredQuotaTypes() {
                return this.quotaTypes.filter(quota => this.eventId || quota.needEventId === false);
            },
            rankingQuotaValueLabel() {
                switch (Number(this.model.quotaType)) {
                    case this.rankingQuotaType.AppellateRegion:
                        return this.$t('rankingCriteria.editor.appellateRegion')
                    case this.rankingQuotaType.Institution:
                        return this.$t('rankingCriteria.editor.institution')
                    case this.rankingQuotaType.Position:
                        return this.$t('rankingCriteria.editor.position')
                    case this.rankingQuotaType.ProfessionalOrientation:
                        return this.$t('rankingCriteria.editor.professionalOrientation')
                    case this.rankingQuotaType.FieldValue:
                        return this.$t('rankingCriteria.editor.fieldValue')
                    default:
                        return '';
                }
            },
            showSearchValueDropdown() {
                return this.model && this.model.quotaType && this.model.quotaType != this.rankingQuotaType.FieldValue;
            }
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new RankingQuota(this.value);
                }
            },
            'model.quotaType': function (newVal, oldVal) {
                const first = this.quotaTypes.find(item => item.value == newVal);
                
                this.model.code = first ? first.code : '';
                this.model.filterValue = '';

                if (this.showSearchValueDropdown) {
                    const ds = this.$refs['rankingQuotaDatasource'];
                    if (ds) {
                        ds.kendoWidget().read();
                    }
                }
            },
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
